import styled from 'styled-components';

export const Container = styled.div`
  /* reserve space for font ascents and descents */
  margin: -10px 0;
  padding: 10px 0;
  overflow: hidden;
  white-space: nowrap;
`;

export const Inner = styled.span`
  display: inline-block;
`;
